import { render } from "./View672.vue?vue&type=template&id=b70e8604"
import script from "./View672.vue?vue&type=script&lang=js"
export * from "./View672.vue?vue&type=script&lang=js"

import "./View672.vue?vue&type=style&index=0&id=b70e8604&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__